module.exports = __webpack_public_path__ + "static/teck_5-309bb3b03a5e18c8ad67719efc535041.jpg";